import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

interface SnapshotRow {
  snapshot_at: string;
  writer_status: "success" | "partial" | "failed";
  writer_errors: Record<string, string> | null;
  counts: Record<string, number>;
}

export function useDashboardSnapshot() {
  return useQuery<SnapshotRow | null>({
    queryKey: ["dashboard_snapshot"],
    queryFn: async () => {
      const { data, error } = await supabaseAgency
        .from("os_dashboard_snapshot").select("*").eq("id", 1).maybeSingle();
      if (error) throw error;
      return data as SnapshotRow | null;
    },
    refetchInterval: 60_000,
  });
}
